import { render, staticRenderFns } from "./RecapitulatifSimple.vue?vue&type=template&id=2909d550&"
import script from "./RecapitulatifSimple.vue?vue&type=script&lang=js&"
export * from "./RecapitulatifSimple.vue?vue&type=script&lang=js&"
import style0 from "./RecapitulatifSimple.vue?vue&type=style&index=0&id=2909d550&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports